import ExcelJS from 'exceljs';
import type { DownloadParams } from './types';

/**
 * 下载/导出方法
 * @param props 下载/导出参数
 */
export async function download(props: DownloadParams): Promise<void> {
  const { fileName, type } = props;

  let fileUrl: string | null = null;

  if (type === 'img') {
    fileUrl = props.url;
  }

  if (type === 'blob') {
    fileUrl = window.URL.createObjectURL(props.blob);
  }

  if (type === 'file') {
    const propName = props.method === 'POST' ? 'data' : 'params';

    const blob = await props.net.download<Blob>({
      url: props.url,
      method: props.method,
      [propName]: props.params
    });
    if (props.sheetName != null) {
      fileUrl = await modifyExcelSheetName(
        blob,
        props.sheetName
      );
    } else {
      fileUrl = window.URL.createObjectURL(blob);
    }
  }

  if (fileUrl == null) {
    /** TODO: 是否要抛出异常？ */
    return;
  }

  const link = document.createElement('a');
  link.href = fileUrl;

  link.setAttribute('download', `${fileName}`);
  document.body.appendChild(link);

  link.click();
  window.URL.revokeObjectURL(fileUrl);
  link.parentNode?.removeChild(link);
}

/**
 * 修改excel第一页sheetName
 * @param blob
 * @param newSheetName
 * @returns
 */
async function modifyExcelSheetName(blob: Blob, newSheetName: string): Promise<string> {
  const workbook = new ExcelJS.Workbook();
  // 将 Blob 转换为 ArrayBuffer
  const arrayBuffer = await blob.arrayBuffer();

  // 从 blob 加载 Excel 文件
  await workbook.xlsx.load(arrayBuffer);

  // 访问第一个 sheet
  const worksheet = workbook.getWorksheet(1);

  // 修改 sheet 名称
  worksheet.name = newSheetName;

  // 将修改后的 Excel 文件转换为 Blob
  const modifiedBlob = await workbook.xlsx.writeBuffer().then(buffer => new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));

  // 生成新的 URL
  const url = window.URL.createObjectURL(modifiedBlob);

  return url;
}
